/* Stevanello Commerce — theme scripts */
(function () {
  'use strict';

  var body = document.body;

  /* ---------------------------------------------- Helpers */
  function on(selector, event, handler, root) {
    (root || document).querySelectorAll(selector).forEach(function (el) {
      el.addEventListener(event, handler);
    });
  }

  function lockScroll(locked) {
    body.classList.toggle('is-locked', locked);
  }

  /* ---------------------------------------------- Overlay */
  var overlay = document.createElement('div');
  overlay.className = 'overlay';
  overlay.setAttribute('data-overlay', '');
  body.appendChild(overlay);

  function closeAllPanels() {
    document.querySelectorAll('.drawer.is-open, .facets.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
    overlay.classList.remove('is-open');
    lockScroll(false);
  }

  overlay.addEventListener('click', closeAllPanels);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });

  /* ---------------------------------------------- Mobile menu drawer */
  on('[data-drawer-open]', 'click', function () {
    var target = document.querySelector(this.getAttribute('data-drawer-open'));
    if (!target) return;
    target.classList.add('is-open');
    overlay.classList.add('is-open');
    lockScroll(true);
  });

  on('[data-drawer-close]', 'click', closeAllPanels);

  /* Collapsible submenus in the drawer */
  on('[data-submenu-toggle]', 'click', function () {
    var expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', String(!expanded));
    var panel = this.nextElementSibling;
    if (panel) panel.classList.toggle('is-open', !expanded);
  });

  /* ---------------------------------------------- Announcement height -> sticky offset */
  function setAnnouncementOffset() {
    var bar = document.querySelector('.announcement--sticky');
    var value = bar ? bar.offsetHeight + 'px' : '0px';
    document.documentElement.style.setProperty('--announcement-height', value);
  }
  setAnnouncementOffset();
  window.addEventListener('resize', setAnnouncementOffset);

  /* ---------------------------------------------- Back to top */
  var backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    window.addEventListener('scroll', function () {
      backToTop.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
  }

  /* ---------------------------------------------- Accordions */
  on('[data-accordion-trigger]', 'click', function () {
    var expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', String(!expanded));
    var panel = this.nextElementSibling;
    if (panel) panel.classList.toggle('is-open', !expanded);
  });

  /* ---------------------------------------------- Facet groups */
  on('[data-facet-toggle]', 'click', function () {
    var expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', String(!expanded));
    var panel = this.nextElementSibling;
    if (panel) panel.classList.toggle('is-hidden', expanded);
  });

  on('[data-facet-form] input', 'change', function () {
    var form = this.closest('[data-facet-form]');
    if (form) form.submit();
  });

  /* ---------------------------------------------- Sort by */
  on('[data-sort-by]', 'change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------------------------------------------- Quantity steppers */
  on('[data-qty-minus]', 'click', function () {
    var input = this.parentElement.querySelector('input');
    var min = parseInt(input.getAttribute('min') || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  on('[data-qty-plus]', 'click', function () {
    var input = this.parentElement.querySelector('input');
    input.value = (parseInt(input.value, 10) || 0) + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  on('[data-cart-qty]', 'change', function () {
    var form = this.closest('form');
    if (form) form.submit();
  });

  /* ---------------------------------------------- Product gallery */
  on('[data-thumb]', 'click', function () {
    var url = this.getAttribute('data-image');
    var main = document.querySelector('[data-main-image]');
    if (main && url) main.setAttribute('src', url);
    document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    this.classList.add('is-active');
  });

  /* ---------------------------------------------- Product variant picker */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var dataEl = picker.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = picker.querySelector('[data-variant-id]');
    var priceEl = picker.querySelector('[data-variant-price]');
    var submit = picker.querySelector('[data-add-to-cart]');

    function currentOptions() {
      return Array.prototype.map.call(
        picker.querySelectorAll('[data-option-index]'),
        function (group) {
          var active = group.querySelector('.product__swatch.is-active');
          return active ? active.getAttribute('data-value') : null;
        }
      );
    }

    function update() {
      var selected = currentOptions();
      var match = variants.find(function (v) {
        return selected.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });

      if (!match) return;

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;

      if (submit) {
        submit.disabled = !match.available;
        var label = submit.querySelector('[data-add-label]');
        if (label) label.textContent = match.available ? submit.getAttribute('data-label-add') : submit.getAttribute('data-label-soldout');
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.querySelectorAll('.product__swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('.product__swatch').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        update();
      });
    });
  });

  /* ---------------------------------------------- Cart notification */
  var notification = document.getElementById('CartNotification');
  var notificationTimer;

  function showNotification(message) {
    if (!notification) return;
    var text = notification.querySelector('.cart-notification__text');
    if (text && message) text.textContent = message;
    notification.hidden = false;
    clearTimeout(notificationTimer);
    notificationTimer = setTimeout(function () { notification.hidden = true; }, 4000);
  }

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------------------------------------------- AJAX add to cart */
  on('[data-ajax-cart]', 'submit', function (event) {
    event.preventDefault();
    var form = this;
    var button = form.querySelector('[type="submit"]');
    var original = button ? button.innerHTML : '';

    if (button) {
      button.disabled = true;
      button.style.opacity = '.65';
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          showNotification(data.description || data.message || 'Nicht verfügbar');
        } else {
          showNotification('Zum Warenkorb hinzugefügt');
          refreshCartCount();
        }
      })
      .catch(function () {
        showNotification('Es ist ein Fehler aufgetreten. Bitte erneut versuchen.');
      })
      .then(function () {
        if (button) {
          button.disabled = false;
          button.style.opacity = '';
          button.innerHTML = original;
        }
      });
  });

  /* ---------------------------------------------- Wishlist (localStorage) */
  var WISHLIST_KEY = 'stevanello:wishlist';

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }

  function paintWishlist() {
    var list = readWishlist();
    document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-wishlist')) !== -1);
    });
  }

  on('[data-wishlist]', 'click', function (e) {
    e.preventDefault();
    var handle = this.getAttribute('data-wishlist');
    var list = readWishlist();
    var index = list.indexOf(handle);
    if (index === -1) { list.push(handle); } else { list.splice(index, 1); }
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (err) {}
    paintWishlist();
  });

  paintWishlist();

  /* ---------------------------------------------- Countdown timers */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) { el.style.display = 'none'; return; }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { el.style.display = 'none'; clearInterval(timer); return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var map = { days: d, hours: h, minutes: m, seconds: s };
      el.querySelectorAll('[data-unit]').forEach(function (unit) {
        var num = unit.querySelector('.countdown__num');
        if (num) num.textContent = String(map[unit.getAttribute('data-unit')]).padStart(2, '0');
      });
    }

    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------------------------------------------- Hero: Kategorie-Tabs + Produkt-Rotation */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-hero-showcase]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hero-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-hero-panel]'));
    if (!tabs.length || !panels.length) return;

    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4000;
    var timer = null;
    var paused = false;

    /* Ein Slider pro Kategorie-Panel */
    var sliders = panels.map(function (panel) {
      var slides = Array.prototype.slice.call(panel.querySelectorAll('[data-hero-slide]'));
      var dotsHost = panel.querySelector('[data-hero-dots]');
      var controls = panel.querySelector('.hero-slider__controls');
      var index = 0;
      var dots = [];

      if (controls && slides.length < 2) controls.hidden = true;

      if (dotsHost && slides.length > 1) {
        slides.forEach(function (slide, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'hero-slider__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Produkt ' + (i + 1) + ' von ' + slides.length);
          dot.addEventListener('click', function () {
            show(i);
            restart();
          });
          dotsHost.appendChild(dot);
          dots.push(dot);
        });
      }

      function show(next) {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.hidden = i !== index;
          slide.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      var prev = panel.querySelector('[data-hero-prev]');
      var next = panel.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(index + 1); restart(); });

      return {
        panel: panel,
        id: panel.getAttribute('data-hero-panel'),
        count: slides.length,
        advance: function () { show(index + 1); },
        reset: function () { show(0); }
      };
    });

    function currentSlider() {
      return sliders.filter(function (s) { return !s.panel.hidden; })[0];
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      stop();
      if (!autoplay || paused) return;
      var slider = currentSlider();
      if (!slider || slider.count < 2) return;
      timer = setInterval(function () {
        var active = currentSlider();
        if (active) active.advance();
      }, speed);
    }

    function restart() { start(); }

    function activate(id, focusTab) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-hero-tab') === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', String(on));
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focusTab) tab.focus();
      });

      sliders.forEach(function (slider) {
        var on = slider.id === id;
        slider.panel.hidden = !on;
        if (on) slider.reset();
      });

      restart();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-hero-tab'), false);
      });

      tab.addEventListener('keydown', function (e) {
        var target = null;
        if (e.key === 'ArrowRight') target = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') target = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') target = tabs[0];
        if (e.key === 'End') target = tabs[tabs.length - 1];
        if (!target) return;
        e.preventDefault();
        activate(target.getAttribute('data-hero-tab'), true);
      });
    });

    /* Rotation anhalten, solange jemand hinschaut oder interagiert */
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function () {
      if (!root.contains(document.activeElement)) { paused = false; start(); }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    start();
  });

  /* ---------------------------------------------- Live-Status (Zeitplan, ohne Server)
     TikTok liefert keinen abfragbaren Live-Status ohne eigenen Server (CORS).
     Deshalb entscheidet der hinterlegte Zeitplan, ausgewertet in der Shop-Zeitzone. */

  var WEEKDAY_NAMES = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  /* Aktuelle Uhrzeit in der Shop-Zeitzone, als "lokales" Date-Objekt zum Rechnen. */
  function nowInZone(timeZone) {
    try {
      var formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: timeZone,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      });
      var parts = {};
      formatter.formatToParts(new Date()).forEach(function (part) { parts[part.type] = part.value; });
      var hour = parts.hour === '24' ? '00' : parts.hour;
      return new Date(
        parseInt(parts.year, 10),
        parseInt(parts.month, 10) - 1,
        parseInt(parts.day, 10),
        parseInt(hour, 10),
        parseInt(parts.minute, 10),
        parseInt(parts.second, 10)
      );
    } catch (e) {
      return new Date();
    }
  }

  function parseTime(value) {
    var match = /^(\d{1,2})[:.](\d{2})$/.exec((value || '').trim());
    if (!match) return null;
    var h = parseInt(match[1], 10);
    var m = parseInt(match[2], 10);
    if (h > 23 || m > 59) return null;
    return { hours: h, minutes: m };
  }

  /* Alle Vorkommen eines Fensters im Bereich gestern bis +14 Tage. */
  function occurrences(win, now) {
    var time = parseTime(win.start);
    if (!time) return [];
    var duration = (parseInt(win.minutes, 10) || 90) * 60000;
    var list = [];

    function push(year, month, day) {
      var start = new Date(year, month, day, time.hours, time.minutes, 0);
      list.push({ start: start, end: new Date(start.getTime() + duration), title: win.title });
    }

    if (win.date) {
      var parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(win.date.trim());
      if (!parts) return [];
      push(parseInt(parts[1], 10), parseInt(parts[2], 10) - 1, parseInt(parts[3], 10));
      return list;
    }

    if (win.weekday === null || win.weekday === undefined) return [];

    for (var offset = -1; offset <= 14; offset++) {
      var day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
      if (day.getDay() === Number(win.weekday)) {
        push(day.getFullYear(), day.getMonth(), day.getDate());
      }
    }
    return list;
  }

  function formatCountdown(ms) {
    var totalMinutes = Math.floor(ms / 60000);
    var days = Math.floor(totalMinutes / 1440);
    var hours = Math.floor((totalMinutes % 1440) / 60);
    var minutes = totalMinutes % 60;
    if (days > 0) return days + ' Tag' + (days === 1 ? '' : 'en') + ' ' + hours + ' Std';
    if (hours > 0) return hours + ' Std ' + minutes + ' Min';
    return minutes + ' Min';
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function describeNext(slot, now) {
    var time = pad(slot.start.getHours()) + ':' + pad(slot.start.getMinutes()) + ' Uhr';
    var sameDay = slot.start.toDateString() === now.toDateString();
    var tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    var isTomorrow = slot.start.toDateString() === tomorrow.toDateString();

    var when;
    if (sameDay) { when = 'heute ' + time; }
    else if (isTomorrow) { when = 'morgen ' + time; }
    else { when = WEEKDAY_NAMES[slot.start.getDay()] + ', ' + pad(slot.start.getDate()) + '.' + pad(slot.start.getMonth() + 1) + '. ' + time; }

    return { when: when, inText: formatCountdown(slot.start - now) };
  }

  document.querySelectorAll('[data-live-status]').forEach(function (root) {
    var mode = root.getAttribute('data-mode');
    var timeZone = root.getAttribute('data-timezone') || 'Europe/Berlin';
    var statusUrl = root.getAttribute('data-status-url');

    var badge = root.querySelector('[data-live-badge]');
    var badgeLabel = root.querySelector('[data-live-badge-label]');
    var buttonLabel = root.querySelector('[data-live-button-label]');
    var headline = root.querySelector('[data-live-headline]');
    var nextEl = root.querySelector('[data-live-next]');

    var windows = [];
    var dataEl = root.querySelector('[data-live-windows]');
    if (dataEl) {
      try { windows = JSON.parse(dataEl.textContent) || []; } catch (e) { windows = []; }
    }

    var override = null; /* aus dem optionalen Status-JSON */

    var profileUrl = root.getAttribute('data-tiktok-profile');
    var liveUrl = root.getAttribute('data-tiktok-live');
    var autoLinks = root.querySelectorAll('[data-tiktok-link]');

    function paint(isLive, next) {
      root.classList.toggle('is-live', isLive);

      /* Automatisch gesetzte TikTok-Links folgen dem Status:
         waehrend eines Live auf /live, sonst auf das Profil. */
      if (profileUrl && liveUrl) {
        autoLinks.forEach(function (link) {
          link.setAttribute('href', isLive ? liveUrl : profileUrl);
        });
      }

      if (badge) {
        badge.classList.toggle('badge--live', isLive);
        badge.classList.toggle('badge--soldout', !isLive);
      }
      if (badgeLabel) {
        badgeLabel.textContent = isLive
          ? root.getAttribute('data-label-live')
          : root.getAttribute('data-label-offline');
      }
      if (buttonLabel) {
        buttonLabel.textContent = isLive
          ? root.getAttribute('data-button-live')
          : root.getAttribute('data-button-offline');
      }
      if (headline) {
        var liveHeadline = root.getAttribute('data-headline-live');
        headline.textContent = isLive && liveHeadline
          ? liveHeadline
          : headline.getAttribute('data-default');
      }

      if (nextEl) {
        var prefix = root.getAttribute('data-next-prefix');
        if (isLive || !next || !prefix) {
          nextEl.hidden = true;
        } else {
          nextEl.hidden = false;
          nextEl.textContent = prefix + ': ' + next.when + ' – in ' + next.inText;
        }
      }
    }

    function evaluate() {
      if (override !== null) { paint(override, null); return; }
      if (mode === 'manual') { return; }

      var now = nowInZone(timeZone);
      var live = false;
      var next = null;

      windows.forEach(function (win) {
        occurrences(win, now).forEach(function (slot) {
          if (now >= slot.start && now < slot.end) { live = true; }
          if (slot.start > now && (!next || slot.start < next.start)) { next = slot; }
        });
      });

      paint(live, next ? describeNext(next, now) : null);
    }

    /* Optionales Status-JSON gewinnt, wenn erreichbar. */
    if (statusUrl) {
      fetch(statusUrl, { cache: 'no-store' })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var value = data.live;
          if (value === undefined) value = data.isLive;
          if (value === undefined && data.status) value = data.status === 'live';
          if (typeof value === 'boolean') { override = value; evaluate(); }
        })
        .catch(function () { /* Zeitplan bleibt maßgeblich */ });
    }

    evaluate();
    setInterval(evaluate, 30000);
  });

  /* ---------------------------------------------- TikTok Creator-Feed (Click-to-load) */
  var tiktokScriptLoaded = false;

  function loadTiktokScript() {
    if (tiktokScriptLoaded) {
      if (window.tiktokEmbed && typeof window.tiktokEmbed.lib === 'object') {
        try { window.tiktokEmbed.lib.render(document.querySelectorAll('.tiktok-embed')); } catch (e) {}
      }
      return;
    }
    tiktokScriptLoaded = true;
    var script = document.createElement('script');
    script.src = 'https://www.tiktok.com/embed.js';
    script.async = true;
    document.body.appendChild(script);
  }

  function renderTiktokEmbed(host) {
    var user = (host.getAttribute('data-username') || '').replace('@', '').trim();
    if (!user) return;

    var profile = 'https://www.tiktok.com/@' + user;
    host.innerHTML =
      '<blockquote class="tiktok-embed" cite="' + profile + '"' +
      ' data-unique-id="' + user + '" data-embed-type="creator"' +
      ' style="max-width:780px;min-width:288px">' +
      '<section><a target="_blank" rel="noopener" href="' + profile + '?refer=creator_embed">@' + user + '</a></section>' +
      '</blockquote>';

    loadTiktokScript();
  }

  document.querySelectorAll('[data-tiktok-embed]').forEach(function (host) {
    if (host.getAttribute('data-consent') === 'true') {
      var button = host.querySelector('[data-tiktok-load]');
      if (button) {
        button.addEventListener('click', function () { renderTiktokEmbed(host); });
      }
    } else {
      renderTiktokEmbed(host);
    }
  });

  /* ---------------------------------------------- Sellay: Live-Code kopieren */

  /* clipboard.writeText gibt es nur in sicheren Kontexten und kann abgelehnt
     werden. Deshalb ein Fallback ueber ein temporaeres Textfeld. */
  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.top = '-1000px';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      area.setSelectionRange(0, text.length);

      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(area);
      if (ok) { resolve(); } else { reject(new Error('copy failed')); }
    });
  }

  /* Die Sektion sellay-live.liquid bringt denselben Handler eigenstaendig mit,
     damit sie auch in einem aelteren Theme allein funktioniert. Laeuft der schon,
     nicht ein zweites Mal binden. */
  if (!window.SellayCopyBound) {
    window.SellayCopyBound = true;

  document.querySelectorAll('[data-sellay-copy]').forEach(function (button) {
    var original = button.textContent.trim();
    var feedback = button.parentElement.querySelector('[data-sellay-feedback]');
    var timer;

    button.addEventListener('click', function () {
      copyToClipboard(button.getAttribute('data-sellay-copy'))
        .then(function () {
          button.textContent = 'Kopiert';
          if (feedback) feedback.textContent = 'Code in die Zwischenablage kopiert.';
        })
        .catch(function () {
          if (feedback) feedback.textContent = 'Kopieren hat nicht geklappt – markiere den Code und kopiere ihn von Hand.';
        })
        .then(function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            button.textContent = original;
            if (feedback) feedback.textContent = '';
          }, 3000);
        });
    });
  });

  }

  /* ---------------------------------------------- Ausklappbare Suche (mobil) */
  on('[data-search-toggle]', 'click', function () {
    var panel = document.getElementById('HeaderSearchPanel');
    if (!panel) return;

    var willOpen = panel.hidden;
    panel.hidden = !willOpen;
    this.setAttribute('aria-expanded', String(willOpen));
    this.setAttribute('aria-label', willOpen ? 'Suche schließen' : 'Suche öffnen');

    if (willOpen) {
      var input = panel.querySelector('[data-search-panel-input]');
      if (input) input.focus();
    }
  });

  /* ---------------------------------------------- Feste Kaufleiste (Produktseite, mobil)
     Erscheint, sobald der eigentliche Kaufbutton aus dem Sichtfeld gescrollt ist. */
  (function setupBuyBar() {
    var bar = document.querySelector('[data-buy-bar]');
    var mainButton = document.querySelector('[data-add-to-cart]');
    if (!bar || !mainButton) return;

    var barLabel = bar.querySelector('[data-buy-bar-label]');
    var barPrice = bar.querySelector('[data-buy-bar-price]');
    var barButton = bar.querySelector('[data-buy-bar-submit]');
    var priceSource = document.querySelector('[data-variant-price]');

    /* Zustand des echten Buttons spiegeln (Varianten, Ausverkauft, Preis) */
    function sync() {
      var soldOut = mainButton.disabled;
      if (barButton) barButton.disabled = soldOut;
      if (barLabel) {
        var mainLabel = mainButton.querySelector('[data-add-label]');
        barLabel.textContent = mainLabel
          ? mainLabel.textContent.trim()
          : (soldOut ? 'Ausverkauft' : 'In den Warenkorb');
      }
      if (barPrice && priceSource) {
        var current = priceSource.querySelector('.price__current');
        if (current) barPrice.textContent = current.textContent.trim();
      }
    }

    if (barButton) {
      barButton.addEventListener('click', function () {
        mainButton.click();
      });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(mainButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        subtree: true,
        childList: true,
        characterData: true
      });
      if (priceSource) {
        new MutationObserver(sync).observe(priceSource, {
          subtree: true,
          childList: true,
          characterData: true
        });
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.hidden = entry.isIntersecting;
        });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(mainButton);
    } else {
      /* Fallback ohne IntersectionObserver */
      window.addEventListener('scroll', function () {
        var rect = mainButton.getBoundingClientRect();
        bar.hidden = rect.bottom > 0 && rect.top < window.innerHeight;
      }, { passive: true });
    }

    sync();
  })();

  /* ---------------------------------------------- Zuschlaege (Hammer + Seite)
     Ein Ablauf fuer beide:
       1. Kunde ist verbunden: customer.metafields.sellay.tiktok_handle
       2. Gesucht wird im ganzen Shop nach Produkten, deren Titel genau diesen
          @namen enthaelt - keine Kategorie, keine Tags.
       3. Gezaehlt und angezeigt werden nur verfuegbare Produkte.
     Liquid sieht von einer Produktliste hoechstens 50 Eintraege, deshalb sucht
     ausschliesslich dieses Script, ueber products.json Seite fuer Seite. */
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var winsRequests = {};
  var WINS_CACHE_MS = 60000;

  /* Aus TikTok/Apps kopierte Namen enthalten oft unsichtbare Zeichen oder
     geschuetzte Leerzeichen - fuer das Auge gleich, fuer den Abgleich nicht. */
  function cleanText(value) {
    return String(value || '')
      .replace(/[​-‍⁠﻿­]/g, '')
      .replace(/[  -   　]/g, ' ')
      .toLowerCase();
  }

  function normalizeHandle(value) {
    return cleanText(value).replace(/\s+/g, '').replace(/^@+/, '');
  }

  /* "@anna" trifft "@anna Jacke" und "Jacke (@anna)", aber weder "@annabell"
     noch "@anna.b": Der Punkt gehoert bei TikTok zum Namen, nur am Ende trennt er. */
  function winsMatcher(handle) {
    var escaped = handle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var pattern = new RegExp('(^|[^a-z0-9_])@' + escaped + '(?![a-z0-9_]|\\.[a-z0-9_])');
    return function (title) { return pattern.test(cleanText(title)); };
  }

  function isAvailable(product) {
    return (product.variants || []).some(function (v) { return v.available; });
  }

  /* Die Zahl fuer den Hammer kurz merken, damit nicht jeder Seitenwechsel den
     ganzen Katalog neu laedt. Die Seite "Meine Zuschlaege" sucht immer frisch. */
  function readWinsCount(handle) {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem('sellay-wins:' + handle) || 'null');
      if (saved && Date.now() - saved.at < WINS_CACHE_MS) return saved.count;
    } catch (e) { /* kein Speicher, dann eben frisch suchen */ }
    return null;
  }

  function storeWinsCount(handle, count) {
    try {
      window.sessionStorage.setItem('sellay-wins:' + handle, JSON.stringify({ count: count, at: Date.now() }));
    } catch (e) { /* egal, naechstes Mal wird frisch gesucht */ }
  }

  function findWins(handle) {
    handle = normalizeHandle(handle);
    if (!handle) return Promise.resolve({ checked: 0, named: 0, products: [] });
    if (winsRequests[handle]) return winsRequests[handle];

    var pageSize = 250;
    var maxPages = 40;
    var matches = winsMatcher(handle);

    function load(page, result) {
      var url = shopRoot + 'products.json?limit=' + pageSize + '&page=' + page;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('products.json ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var products = data.products || [];
          result.checked += products.length;
          products.forEach(function (p) {
            if (!matches(p.title)) return;
            result.named += 1;
            if (isAvailable(p)) result.products.push(p);
          });
          if (products.length === pageSize && page < maxPages) return load(page + 1, result);
          return result;
        });
    }

    winsRequests[handle] = load(1, { checked: 0, named: 0, products: [] })
      .then(function (result) {
        storeWinsCount(handle, result.products.length);
        return result;
      }, function (err) {
        delete winsRequests[handle];
        throw err;
      });
    return winsRequests[handle];
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(amount) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2).replace('.', ',') + ' ' + currency;
    }
  }

  /* Der Hammer bleibt immer sichtbar, nur die Zahl kommt und geht */
  function showGavelCount(count) {
    document.querySelectorAll('[data-gavel]').forEach(function (el) {
      el.querySelectorAll('[data-gavel-count]').forEach(function (c) {
        c.textContent = count;
        c.hidden = count === 0;
      });
      if (el.hasAttribute('aria-label')) {
        el.setAttribute('aria-label', count > 0 ? count + ' ersteigerte Artikel ansehen' : 'Meine Zuschläge');
      }
    });
  }

  /* Hammer im Header */
  (function () {
    var source = document.querySelector('[data-gavel-handle]');
    if (!source || !window.fetch) return;

    var handle = normalizeHandle(source.getAttribute('data-gavel-handle'));
    if (!handle) return;

    var cached = readWinsCount(handle);
    if (cached !== null) {
      showGavelCount(cached);
      return;
    }
    findWins(handle).then(function (result) {
      showGavelCount(result.products.length);
    }).catch(function () {
      /* Netzwerkfehler: ohne Zahl ist der Hammer trotzdem da */
    });
  })();

  /* Seite "Meine Zuschlaege" */
  (function () {
    var box = document.querySelector('[data-wins-page]');
    if (!box) return;

    var diag = document.querySelector('[data-wins-diag]');
    var handle = normalizeHandle(box.getAttribute('data-wins-handle'));

    function text(name) { return box.getAttribute('data-wins-' + name) || ''; }

    function renderMessage(message, extra) {
      box.innerHTML = '<div class="sellay-wins__empty"><p>' + escapeHtml(message) + '</p>' + (extra || '') + '</div>';
    }

    function renderError(err) {
      if (diag) diag.textContent = 'Fehler beim Laden: ' + (err && err.message ? err.message : err);
      renderMessage(text('error'),
        '<button class="sellay-wins__button sellay-wins__button--ghost" type="button" data-wins-retry>Erneut versuchen</button>');
      var retry = box.querySelector('[data-wins-retry]');
      if (retry) retry.addEventListener('click', function () { window.location.reload(); });
    }

    if (!handle) return;
    if (!window.fetch) {
      renderError('Browser zu alt');
      return;
    }

    findWins(handle).then(function (result) {
      var found = result.products;
      if (diag) {
        diag.textContent = result.checked + ' Produkte geprüft · ' + result.named + ' mit @' + handle +
          ' im Titel · davon ' + found.length + ' verfügbar';
      }
      showGavelCount(found.length);

      if (!found.length) {
        renderMessage(text('empty'), '<p class="sellay-win__sold">Verbunden als @' + escapeHtml(handle) + '</p>');
        return;
      }

      var items = '';
      var total = 0;

      found.forEach(function (p, index) {
        var variant = (p.variants || []).filter(function (v) { return v.available; })[0];
        var price = parseFloat(variant.price) || 0;
        var url = shopRoot + 'products/' + p.handle;
        var image = variant.featured_image && variant.featured_image.src ||
          (p.images && p.images[0] ? p.images[0].src : '');
        if (image) image += (image.indexOf('?') === -1 ? '?' : '&') + 'width=200';
        total += price;

        /* Die Felder gehoeren in das li, nicht zwischen die Listenpunkte:
           direkt im ul waeren sie ungueltiges HTML. */
        items += '<li class="sellay-win">' +
          '<a class="sellay-win__media" href="' + escapeHtml(url) + '">' +
            (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(p.title) + '" width="100" height="100" loading="lazy">' : '') +
          '</a>' +
          '<div class="sellay-win__body">' +
            '<h2 class="sellay-win__title"><a href="' + escapeHtml(url) + '">' + escapeHtml(p.title) + '</a></h2>' +
            '<span class="sellay-win__price">' + escapeHtml(formatMoney(price)) + '</span>' +
          '</div>' +
          '<input type="hidden" name="items[' + index + '][id]" value="' + escapeHtml(variant.id) + '">' +
          '<input type="hidden" name="items[' + index + '][quantity]" value="1">' +
        '</li>';
      });

      box.innerHTML =
        '<p class="sellay-wins__note">Verbunden als @' + escapeHtml(handle) + ' · ' + found.length +
          ' Artikel für dich reserviert</p>' +
        '<form action="' + escapeHtml(text('cart')) + '" method="post">' +
          '<ul class="sellay-wins__list">' + items + '</ul>' +
          '<div class="sellay-wins__summary">' +
            '<div class="sellay-wins__total">' + escapeHtml(formatMoney(total)) +
              '<span>' + found.length + ' Artikel gesamt, zzgl. Versand</span></div>' +
            '<button class="sellay-wins__button" type="submit">' + escapeHtml(text('button')) + '</button>' +
          '</div>' +
        '</form>';
    }).catch(renderError);
  })();
})();
